import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { YearlyResultByWeekReportShopService } from './yearly-result-by-week-report-shop.service';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-yearly-result-by-week-report-shop',
  standalone: false,
  templateUrl: './yearly-result-by-week-report-shop.component.html',
  styleUrl: './yearly-result-by-week-report-shop.component.scss'
})
export class YearlyResultByWeekReportShopComponent {

  title: string = "Yearly Result By Week";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  shopListData: any = [];
  datePipe: any;
  permission: any;
  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private yearlyResultByWeekReportShopService: YearlyResultByWeekReportShopService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    this.editForm = this.builder.group({
      year: this.builder.control(null),
      week_no: this.builder.control([]),
    });

    this.currentYear = new Date().getFullYear();
    this.permission = permissionService.getPagePermission("yearly-result-by-week-shop");
    console.log(this.permission);
  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }








  ngOnInit(): void {
    this.loadData();



  }


  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Map the weeks to the format needed for the dropdown
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }


  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately




  curFinYear!: string; // Add this to your component properties

  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };

  }


  loadData(): void {
    let requestData = this.buildRequestData();
    this.yearlyResultByWeekReportShopService.getWeekNoList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.financialYears = response.data.finYears;
        this.years = this.financialYears.map(fy => fy.year);
        this.curFinYear = response.data.curFinYear;
        const currentYearValue = parseInt(this.curFinYear.split('-')[0]);

        // Filter financialYears to include only up to the current year
        this.financialYears = response.data.finYears.filter((fy: any) =>
          fy.year <= currentYearValue
        );
        this.years = this.financialYears.map(fy => fy.year);

        if (!this.editForm.get('year')?.value) {
          const currentYearValue = parseInt(this.curFinYear.split('-')[0]); // Adjust based on curFinYear format
          const currentFinYear = this.financialYears.find(fy => fy.year === currentYearValue);

          if (currentFinYear) {
            this.editForm.get('year')?.setValue(currentYearValue, { emitEvent: false });

            let weeksArray = currentFinYear.weeks;
            const currentWeek = this.getCurrentWeek(weeksArray);

            // Filter weeks if current year
            if (currentWeek) {
              weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
            }

            this.weeks = weeksArray.map((week: any) => ({
              ...week,
              displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
            }));

            // Set current week or first week
            if (currentWeek) {
              this.editForm.get('week_no')?.setValue(currentWeek.week_no);
            } else if (this.weeks.length > 0) {
              this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
            }
          }
        }
      }
    });
  }
  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }







  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }

  reset(sourceList: any[]): any {
    sourceList.forEach(el => {
      el.selected = false;
    });
  }




  navigateToWeeklyReport() {
    this.router.navigate(['/ytd-result-by-branch-view']);
    // or with parameters if needed:
    // this.router.navigate(['/weekly-result-store-report-view', {param: value}]);
  }

  exportClicked(): void {
    this.IsDownloading = true;
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedShopIds = this.shopListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);
    const userStr = sessionStorage.getItem('user');
    let shopIdArray: number[] = [];

    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.shop_id) {
          shopIdArray = [Number(user.shop_id)]; // Convert to number and wrap in array
        }
      } catch (err) {
        console.error('Error parsing user from sessionStorage:', err);
      }
    }

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      reportOption: "store",
      filterOption: "none",
      filterIds: shopIdArray,
    };

    if (reportData) {
      this.yearlyResultByWeekReportShopService.yearlyResultByWeekExportList(reportData).subscribe({
        next: (response) => {
          // Handle "No data found" response
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data!!!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }
            } catch (e) {
              // Not JSON, treat as file
              const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'Yearly-Result-By-Week-Report.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;
              return;
            }
            // If JSON but not NO_DATA_FOUND, treat as error
            this.IsDownloading = false;
          };
          reader.readAsText(response);
        },
        error: (error) => {
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }


}
